'use client';

import Link from 'next/link';
import {useState} from 'react';

import CSS from './Items.module.scss';
import Vector from '@/components/elements/vector/Vector';
import {resolveRoute} from '@/lib/routes';

const urls = () =>
  ({
    titles: [
      {title: 'محصولات', key: 'products'},
      {title: 'درباره بیت‌یک', key: 'about'},
      {title: 'خدمات', key: 'services'},
      {title: 'قیمت ارزهای دیجیتال', key: 'prices'}
    ],
    products: [
      {
        title: 'چت بات AI',
        url: resolveRoute('base.chat')
      },
      {
        title: 'معامله اسپات',
        url: resolveRoute('base.trade')
      },
      {
        title: resolveRoute('base.otc', undefined, true),
        url: resolveRoute('base.otc')
      },
      {
        title: resolveRoute('base.stacking', undefined, true),
        url: resolveRoute('base.stacking')
      },
      {
        title: resolveRoute('base.signal', undefined, true),
        url: resolveRoute('base.signal')
      }
    ],
    about: [
      {
        title: resolveRoute('base.about', undefined, true),
        url: resolveRoute('base.about')
      },
      {
        title: resolveRoute('base.contact', undefined, true),
        url: resolveRoute('base.contact')
      },
      {
        title: resolveRoute('base.terms', undefined, true),
        url: resolveRoute('base.terms')
      },
      {
        title: resolveRoute('base.user-levels', undefined, true),
        url: resolveRoute('base.user-levels')
      },
      {
        title: resolveRoute('base.fee-levels', undefined, true),
        url: resolveRoute('base.fee-levels')
      },
      {
        title: resolveRoute('base.invitation', undefined, true),
        url: resolveRoute('base.invitation')
      },
      {
        title: resolveRoute('base.faq', undefined, true),
        url: resolveRoute('base.faq')
      },
      {
        title: resolveRoute('base.security', undefined, true),
        url: resolveRoute('base.security')
      }
    ],
    services: [
      {
        title: 'پشتیبانی ۲۴/۷',
        url: resolveRoute('base.support')
      },
      {
        title: resolveRoute('base.free-transfer', undefined, true),
        url: resolveRoute('base.free-transfer')
      },
      {
        title: resolveRoute('base.blog', undefined, true),
        url: resolveRoute('base.blog')
      },
      {
        title: 'نقشه سایت',
        url: resolveRoute('base.sitemap')
      }
    ],
    prices: [
      {
        title: 'بیتکوین',
        url: resolveRoute('base.markets.coin', {coin: 'btc'})
      },
      {
        title: 'اتریوم',
        url: resolveRoute('base.markets.coin', {coin: 'eth'})
      },
      {
        title: 'تتر',
        url: resolveRoute('base.markets.coin', {coin: 'usdt'})
      },
      {
        title: 'تون کوین',
        url: resolveRoute('base.markets.coin', {coin: 'ton'})
      }
    ]
  } as const);

export default function Items() {
  const _urls = urls();
  const [openItem, setOpenItem] = useState('');

  return (
    <>
      {_urls.titles.map((item, index) => (
        <div key={index} className={CSS.item}>
          <div
            onClick={() =>
              setOpenItem(state => (state === item.title ? '' : item.title))
            }>
            <h5>{item.title}</h5>
            <Vector
              name="IoIosArrowBack"
              className={openItem === item.title ? CSS.rotateArrow : undefined}
            />
          </div>
          <ul className={openItem === item.title ? CSS.open : undefined}>
            {_urls[item.key].map((item, index) => (
              <li key={index}>
                <Link href={item.url}>{item.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}
